import {
  useGetPlaybookQuery,
  useGetWorkspaceQuery,
  useLazyGetFolderQuery,
} from '@carboncopyco/data';
import { Breadcrumbs } from '@carboncopyco/ui';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePlaybookPageProps } from './PlaybookPageContext';

export const PlaybookPageBreadcrumbs = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { organizationId, playbookId } = usePlaybookPageProps();
  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });
  const { data: playbook } = useGetPlaybookQuery({
    organizationId,
    workspaceId,
    id: playbookId,
  });
  const [getFolder, { data: folder }] = useLazyGetFolderQuery();

  const links = useMemo(
    () => [
      {
        label: workspace?.workspaceName,
        onClick: () => navigate(`/${organizationId}/workspace/${workspaceId}`),
      },
    ],
    [navigate, organizationId, workspace?.workspaceName, workspaceId]
  );

  useEffect(() => {
    if (playbook?.folderId) {
      getFolder({
        organizationId,
        workspaceId,
        folderId: String(playbook.folderId),
      });
    }
  }, [getFolder, organizationId, workspaceId, playbook]);

  const getDemoPageLinks = useMemo(() => {
    if (folder && playbook?.folderId) {
      return [
        ...links,
        {
          label: folder.name,
          onClick: () =>
            navigate(
              `/${organizationId}/workspace/${workspaceId}/folder/${playbook.folderId}`
            ),
        },
      ];
    }
    return links;
  }, [
    folder,
    links,
    navigate,
    organizationId,
    playbook?.folderId,
    workspaceId,
  ]);

  return (
    <Breadcrumbs
      current={playbook?.name}
      links={getDemoPageLinks}
    />
  );
};
